import { EventDateDisplay } from 'src/components/Events/EventInfo';
import { useContent } from 'src/contexts/ContentContext';
import { Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './OnSaleEventDetails.css';

export const OnSaleDateBanner = ({
  onSaleDate,
  primary,
}: {
  onSaleDate: string | null;
  primary: string | null;
}) => {
  const onSaleDateText = useContent(ContentId.OnSaleDate);
  if (!onSaleDate) {
    return;
  }
  return (
    <Stack
      gap="m"
      justifyContent="spaceBetween"
      className={styles.onSaleDateBanner}
      alignItems="center"
    >
      <Stack gap="m">
        <div>{`${onSaleDateText}:`}</div>
        <EventDateDisplay
          eventDateString={onSaleDate}
          eventDateFormat={'MMM d, y'}
        />
      </Stack>
      <div>{primary}</div>
    </Stack>
  );
};
